import React, { useState } from 'react';
import { Box, Tab } from '@mui/material'
import { TabContext, TabList, TabPanel } from '@mui/lab'
import './About.css'
import { SiJquery, SiNextdotjs, SiJavascript, SiMongodb, SiNpm } from 'react-icons/si';
import { FaReact, FaBootstrap, FaNodeJs, FaWordpress, FaHtml5, FaCss3Alt, FaGitAlt } from 'react-icons/fa';
import { HiCommandLine } from 'react-icons/hi2';


export default function About() {

    const [value, setValue] = useState('1')
    const handleChange = (event, newValue) => {
        setValue(newValue)
    }
    
  return (

    <div className="about-container">
        <div className="row about-intro mb-4">
            <div className="col-12 col-lg-4">
                <div className="about-picture d-flex">
                    <div className="about-picture-background"></div>

                </div>
            </div>
            <div className="col-12 col-lg-8">
                <div className="about-details">
                    <span className="about-headline">
                    <h1>About <span className="underline">Me</span></h1>
                    </span>
                    <span className="about-intro">
                        <p>Welcome to my portfolio!<br/>
                        As a full stack developer, I have been earnestly providing small and medium businesses with fully-fledged and customized web solutions.<br/>
                        With each project, I take pride in delivering optimized functionalities and use problem-solving skills to meet the unique needs of my clients.<br/>
                        My expertise lies in both front-end and back-end development, and I am constantly seeking out opportunities to automate tasks and streamline processes.<br/>
                        While I enjoy the technical aspects of my work, I also have a keen eye for design and strive to provide the best possible user experience through thoughtful and creative design details.<br/>
                        </p>
                
                    </span>

                </div>
            </div>
        </div>
        <div className="row about-skills">
        <span className="about-headline">
        <h1>My <span className="underline">Skills</span></h1>
        </span>
            <p>
            I listed below all tools and technologies that I have been working with for building awesome stuff.
            </p>
        <div className="skills-details">
             
            <TabContext value={value}>
                <Box>
                    <TabList 
                        aria-label='Tabs example' 
                        onChange={handleChange}
                        TabIndicatorProps={{sx: {backgroundColor: 'transparent'}}}
                        sx={{
                            "& button": { color: 'aliceblue', fontSize: "12px"},
                            "& button.Mui-selected": { color: "aliceblue", fontSize:"15px", backgroundColor:"#088395", borderRadius: "5px"},
                            '& .MuiTabs-flexContainer': { flexWrap: 'wrap',},

                        }}
                        >
                        <Tab label='Front-end' value='1'/>
                        <Tab label='Back-end' value='2' />
                        <Tab label='CMS' value='3' />
                    </TabList>
                
                </Box>

                <TabPanel className={`d-flex flex-wrap p-2 ${value === '1' ? 'd-block' : 'd-none'}`} value='1'>
                    <span className="skill d-flex flex-column justify-content-center"><SiJavascript size="3em" color="#00ffca"/>Javascript</span>
                    <span className="skill d-flex flex-column"><FaReact size="3em" color="#00ffca"/>React</span>
                    <span className="skill d-flex flex-column"><SiNextdotjs size="3em" color="#00ffca"/>Next.js</span>
                    <span className="skill d-flex flex-column"><SiJquery size="3em" color="#00ffca"/> jQuery </span>
                    <span className="skill d-flex flex-column"><FaBootstrap size="3em" color="#00ffca"/>Bootstrap</span>
                    <span className="skill d-flex flex-column"><FaHtml5 size="3em" color="#00ffca"/>HTML5</span>
                    <span className="skill d-flex flex-column"><FaCss3Alt size="3em" color="#00ffca"/>CSS</span>
                </TabPanel>
                <TabPanel className={`d-flex flex-wrap p-2 ${value === '2' ? 'd-block' : 'd-none'}`} value='2'>
                    <span className="skill d-flex flex-column"><FaNodeJs size="3em" color="#00ffca"/>Nodejs</span>
                    <span className="skill d-flex flex-column"><SiMongodb size="3em" color="#00ffca"/>Mongodb</span>
                    <span className="skill d-flex flex-column"><FaGitAlt size="3em" color="#00ffca"/>Git</span>
                    <span className="skill d-flex flex-column"><SiNpm size="3em" color="#00ffca"/>Npm</span>
                    <span className="skill d-flex flex-column"><HiCommandLine size="3em" color="#00ffca"/>Command Line</span>
                </TabPanel>
                <TabPanel className={`d-flex flex-wrap p-2 ${value === '3' ? 'd-block' : 'd-none'}`} value='3'>
                    <span className="skill d-flex flex-column"><FaWordpress size="3em" color="#00ffca"/>WordPress</span>
                </TabPanel>
            </TabContext>
            </div>
            <div className="about-btn">
                <a href="resume.pdf" download="Walid Bouloukt.pdf">
                    <button className="btn highlighted-btn">Get Resume</button>
                </a>
            </div>
        </div>
    </div>
  )
}
